// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"baddceaa","628":"0cbb3c87","963":"e084680b","988":"522cddba"}[chunkId] + ".chunk.js";
};